import { render, staticRenderFns } from "./ArticleButton.vue?vue&type=template&id=4e4c0b8f&scoped=true&"
import script from "./ArticleButton.vue?vue&type=script&lang=js&"
export * from "./ArticleButton.vue?vue&type=script&lang=js&"
import style0 from "./ArticleButton.vue?vue&type=style&index=0&id=4e4c0b8f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4c0b8f",
  null
  
)

export default component.exports